import { SignupForm, type SignupFormData, register } from '@trafiflow/shared-ui'
import { API_CONFIG } from '@/shared/config'

export default function Signup() {
  const handleSignup = async (data: SignupFormData) => {
    try {
      // 1. Crear el tenant en nuestro backend (esto crea el subtenant en AgentPlat y el registro en DB)
      const apiResponse = await fetch(`${API_CONFIG.baseUrl}/tenants`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          organizationName: data.organizationName,
          organizationSlug: data.organizationSlug,
          adminEmail: data.email,
          adminName: data.name,
        }),
      })

      const result = await apiResponse.json()

      if (!apiResponse.ok || !result.success) {
        return { error: new Error(result.error || 'Failed to create organization') }
      }

      // 2. Registrar el usuario en Cognito con el tenantId confirmado por el backend
      const tenantId = result.data.tenantId

      return await register(
        data.email,
        data.password,
        tenantId
      )
    } catch (err) {
      console.error('[Signup] error:', err)
      return { error: err instanceof Error ? err : new Error('An unexpected error occurred') }
    }
  }

  return (
    <SignupForm
      onSignup={handleSignup}
      appName="NextStore Customer Portal"
    />
  )
}











